import {
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  GET_USER_DETAIL_FAIL,
  GET_USER_DETAIL_SUCCESS,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  CLEAR_MESSAGE,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  RESET_DATA,
  UPDATE_SEASON_CHANGE_STATUS_SUCCESS,
  UPDATE_SEASON_CHANGE_STATUS_FAIL,
  BLACKLIST_USER_FAIL,
  BLACKLIST_USER_SUCCESS,
  GET_UNAPPROVE_COUNT_SUCCESS,
  GET_UNAPPROVE_COUNT_FAIL,
  GET_EXPORT_USERS_SUCCESS,
  GET_EXPORTED_USERS_FAIL,
  RESET_EXPORT_DATA,
  CLEAR_STRIPE_ERROR,
  CHARGE_USER_SUCCESS,
  CHARGE_USER_FAIL,
  GET_BILL_PRICE_SUCCESS,
  GET_BILL_PRICE_FAIL,
  GET_CHANGESEASON_USERS_FAIL,
  GET_CHANGESEASON_USERS_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  userList: [],
  userDetail: {},
  error: {},
  isStripeError: false,
  message: "",
  pagination: {},
  search: "",
  unApprovalCount: {},
  file: "",
  userChangeSeasonList: [],
}

const users = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        userList: action.payload?.data,
        pagination: action.payload?.pagination || {},
      }

    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_USER_SUCCESS:
      return {
        ...state,
        userList: [...state.userList, action?.payload?.data || {}],
        message: action?.payload?.message || "",
      }

    case ADD_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        userDetail: action.payload,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        message: "Successfully user updated!",
        userList: [],
        isStripeError: action.payload.response?.isStripeError,
        // userList: (state?.userList || []).map(user => {
        //   return user._id.toString() === action.payload?.data._id.toString()
        //     ? { user, ...action.payload?.data }
        //     : user
        // }),
      }

    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        isStripeError: action.payload.response?.isStripeError,
      }

    case GET_USER_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        message: "Successfully user deleted!",
        isStripeError: action.payload.response?.isStripeError,
        userList: (state?.userList || []).filter(
          user => user._id.toString() !== action.payload.user._id.toString()
        ),
      }

    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        isStripeError: action.payload?.isStripeError,
      }
    case BLACKLIST_USER_SUCCESS:
      return {
        ...state,
        message: "Successfully user blacklisted!",
        userList: [],
      }

    case BLACKLIST_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }
    case CLEAR_STRIPE_ERROR:
      return {
        ...state,
        isStripeError: false,
      }
    case RESET_DATA:
      return {
        ...state,
        error: {},
        message: "",
        userList: [],
      }
    case UPDATE_SEASON_CHANGE_STATUS_SUCCESS:
      return {
        ...state,
        message: "Successfully user updated!",
        userList: [],
      }

    case UPDATE_SEASON_CHANGE_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_UNAPPROVE_COUNT_SUCCESS:
      return {
        ...state,
        unApprovalCount: action.payload?.data,
      }

    case GET_UNAPPROVE_COUNT_FAIL:
      return {
        ...state,
        unApprovalCount: {},
        error: action.payload,
      }
    case GET_EXPORT_USERS_SUCCESS:
      return {
        ...state,
        message: action.payload?.message,
        file: action.payload?.file,
        error: {},
      }

    case GET_EXPORTED_USERS_FAIL:
      return {
        ...state,
        file: "",
        error: action.payload?.message || "Error occurred in export file.",
      }

    case RESET_EXPORT_DATA:
      return {
        ...state,
        error: {},
        message: "",
        file: "",
      }

    case CHARGE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CHARGE_USER_SUCCESS:
      return {
        ...state,
        message: "Successfully charged user!"
      }

    case GET_BILL_PRICE_FAIL:
      return {
        ...state,
        price: 0,
        error: action.payload,
      }

    case GET_BILL_PRICE_SUCCESS:
      return {
        ...state,
        price: action?.payload || 0
        // message: "Successfully priced bill!"
      }
    case GET_CHANGESEASON_USERS_SUCCESS:
      return {
        ...state,
        userChangeSeasonList: action.payload?.data,
        pagination: action.payload?.pagination || {},
      }

    case GET_CHANGESEASON_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default users
